module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Heavy.a7edaaca.otf";